import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import imgDash from "../assets/images/Rocky/LOGOROCKYPeque.png";
import { jwtDecode } from "jwt-decode";
import User from "../models/user";
import {
  ClipboardPlus, HeadphonesIcon, FilePlus2, ChevronsDown, Library, Scaling, ChartColumnDecreasing, NotepadTextDashed, GalleryHorizontal, UserCheck, UsersRound, Hospital, List, Smartphone,
  Newspaper, Rows4, ListCheck
} from "lucide-react";

export const Sidebar = ({
  isOpen,
  toggleSidebar,
}: {
  isOpen: boolean;
  toggleSidebar: () => void;
}) => {
  const location = useLocation();
  //Variables to all tsx
  const myNavigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);
  const [isSupportMenuOpen, setIsSupportMenuOpen] = useState<string | null>(null);
  // const [isMunicipiosMenuOpen, setIsMunicipiosMenuOpen] = useState(false);
  const [arrayUsers, setArrayUsers] = useState<User>();

  const toggleSupportMenu = (menuName: string) => {
    setIsSupportMenuOpen(prev => (prev === menuName ? null : menuName));
  };

  const onRouteChanged = () => {
    const sidebar = document.querySelector("#sidebar");
    if (sidebar) {
      sidebar.classList.remove("active");
    }

    const dropdownPaths = [
      { path: "/apps", state: "appsMenuOpen" },
      { path: "/basic-ui", state: "basicUiMenuOpen" },
      { path: "/advanced-ui", state: "advancedUiMenuOpen" },
      { path: "/form-elements", state: "formElementsMenuOpen" },
      { path: "/aps-rocky", state: "apsRockyOpen" },
    ];

    dropdownPaths.forEach((obj) => {
      // if (isPathActive(obj.path)) {
      //   setMenuState((prevState) => ({ ...prevState, [obj.state]: true }));
      // }
    });
  };

  // const [isOpen, setIsOpen] = useState(true); // Estado para controlar si se muestra el sidebar

  // const toggleSidebar = () => {
  //   setIsOpen(!isOpen); // Cambia el estado al hacer clic
  // };

  // const isPathActive = (path: string): boolean => {
  //   return location.pathname.startsWith(path);
  // };
  //function to error the Token on the time, using when token is invalid or expired
  const handleTokenError = () => {
    myNavigate("/"); // Redirigir a la página de inicio de sesión
  };

  const getProfessionals = async () => {
    try {
      const token: any = localStorage.getItem("access");
      if (!token) {
        handleTokenError();
        return;
      }
      const decoded: any = jwtDecode(token);

      if (decoded && decoded.role) {
        setArrayUsers(decoded);
        setLoading(false);
        return;
      } else {
        console.error("El token no contiene información de usuario válida.");
        handleTokenError();
      }

    } catch (error) {
      console.error("Error fetching professionals:", error);
      setLoading(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError();
      }
    }
  };

  const isActive = (path: any) => location.pathname === path;

  useEffect(() => {
    onRouteChanged();
    getProfessionals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  return (
    <>
      <button
        onClick={toggleSidebar}
        style={{
          position: "fixed",
          top: "20px",
          left: isOpen ? "140px" : "10px", // Se mueve dependiendo del estado
          zIndex: 1000,
          backgroundColor: isOpen ? "#dcc05d" : "#0f0f6f",
          color: isOpen ? "#0f0f6f" : "#ffffff",
          border: "none",
          padding: "5px",
          cursor: "pointer",
          borderRadius: "50%",
          fontWeight: "bold",
          fontSize: "1.2rem",
        }}
      >
        {isOpen ? <i className="fa-regular fa-eye-slash"></i> : <i className="fa-regular fa-eye"></i>}
      </button>
      <nav
        className={`sidebar sidebar-offcanvas position-fixed ${isOpen ? "d-block" : "d-none"
          }`}
        id="sidebar"
        style={{
          background: "linear-gradient(to right, #0F0F6F 86%, #EBEFF3 101%)",
          paddingLeft: "0!important",
          marginLeft: "0!important",
          borderRight: "1px solid #ccc",
          height: "100vh",
        }}
      >
        <a href="/home/main">
          <img
            src={imgDash}
            alt="Logo Rocky"
            style={{
              width: "30px",
              height: "auto",
              marginLeft: "90px",
              marginTop: "20px",
              paddingBottom: "20px",
            }}
          />
        </a>
        <ul
          className="nav"
          style={{
            overflowY: "auto",
            margin: "0",
            background: "transparent",
          }}
        >
          <li className="nav-item navbar-brand-mini-wrapper">
            <Link className="nav-link navbar-brand brand-logo-mini" to="/home">
              {/* <img src={imgDash} alt="logo" /> */}
            </Link>
          </li>

          <li style={{ margin: "0 !important" }} className="nav-item">
            <span
              className="nav-link fs-5 fw-bold text-white"
              onClick={() => toggleSupportMenu("support")}
              style={{
                cursor: "pointer",
                paddingLeft: "15px",
                marginLeft: "0 !important",
                color: "white",
                backgroundColor: "transparent !important",
              }}
            >
              <HeadphonesIcon size={18} />&nbsp;Soporte
            </span>

            {/* Menú desplegable */}
            {isSupportMenuOpen === "support" && (
              <div className={`submenu ${isSupportMenuOpen === "support" ? "open" : ""}`}>
                <ul
                  className="nav flex-column ms-3"
                  style={{
                    paddingLeft: "0",
                    background: "transparent",
                  }}
                >
                  <li className="nav-item">
                    <Link
                      className="nav-link fw-bold"
                      to="/home/create-support"
                      style={{
                        padding: isActive("/home/create-support")
                          ? "10px 15px"
                          : "",
                        color: isActive("/home/create-support") ? "#dcc05d" : "",
                        backgroundColor: isActive("/home/create-support")
                          ? "#dcc05d !important"
                          : "",
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                      }}
                    >
                      <FilePlus2 size={18} />&nbsp;Nuevo
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link fw-bold"
                      to="/home/support-view"
                      style={{
                        padding: isActive("/home/support-view")
                          ? "10px 15px"
                          : "",
                        color: isActive("/home/support-view") ? "#dcc05d" : "",
                        backgroundColor: isActive("/home/support-view")
                          ? "#dcc05d !important"
                          : "",
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                      }}
                    >
                      <ChevronsDown size={18} />&nbsp;Mis pendientes
                    </Link>
                  </li>
                  <li className="nav-item" style={{ color: "white" }}>
                    <Link
                      className="nav-link fw-bold"
                      to="/home/view-mysupport"
                      style={{
                        padding: isActive("/home/view-mysupport")
                          ? "10px 15px"
                          : "",
                        color: isActive("/home/view-mysupport") ? "#dcc05d" : "",
                        backgroundColor: isActive("/home/view-mysupport")
                          ? "#dcc05d !important"
                          : "",
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                      }}
                    >
                      <Library size={18} />&nbsp;Mis soportes
                    </Link>
                  </li>
                  <li className="nav-item" style={{ color: "white" }}>
                    <Link
                      className="nav-link fw-bold"
                      to="/home/view-send-support"
                      style={{
                        padding: isActive("/home/view-send-support")
                          ? "10px 15px"
                          : "",
                        color: isActive("/home/view-send-support")
                          ? "#dcc05d"
                          : "",
                        backgroundColor: isActive("/home/view-send-support")
                          ? "#dcc05d !important"
                          : "",
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                      }}
                    >
                      <Scaling size={18} />&nbsp;Escalados
                    </Link>
                  </li>
                  {arrayUsers?.role === "ADMINISTRADOR" ? (
                    <>
                      <li className="nav-item">
                        <Link
                          className="nav-link fw-bold"
                          to="/home/support-view-final"
                          style={{
                            padding: isActive("/home/support-view-final")
                              ? "10px 15px"
                              : "",
                            color: isActive("/home/support-view-final")
                              ? "#dcc05d"
                              : "",
                            backgroundColor: isActive("/home/support-view-final")
                              ? "#dcc05d !important"
                              : "",
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          <ChartColumnDecreasing size={18} />&nbsp;Estadísticas
                        </Link>
                      </li>
                      {/* <li className="nav-item">
                      <Link
                        className="nav-link fw-bold"
                        to="/home/view-login-private"
                        style={{
                          padding: isActive("/home/view-login-private")
                            ? "10px 15px"
                            : "",
                          color: isActive("/home/view-login-private")
                            ? "#dcc05d"
                            : "",
                          backgroundColor: isActive("/home/view-login-private")
                            ? "#dcc05d !important"
                            : "",
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                        }}
                      >
                        Eliminación
                      </Link>
                    </li> */}
                    </>
                  ) : (
                    ""
                  )}
                </ul>
              </div>

            )}
          </li>

          <li style={{ color: "black" }} className="nav-item">
            <span
              className="nav-link fs-5 fw-bold text-white"
              onClick={() => toggleSupportMenu("templates")}
              style={{
                cursor: "pointer",
                padding: "10px 15px",
                color: "white !important",
                backgroundColor: "transparent !important",
              }}
            >
              <NotepadTextDashed size={18} />&nbsp;Plantillas
            </span>

            {/* Menú desplegable de Usuarios */}
            {isSupportMenuOpen === "templates" && (
              <div className={`submenu ${isSupportMenuOpen === "templates" ? "open" : ""}`}>
                <ul
                  className="nav flex-column ms-3"
                  style={{ background: "transparent" }}
                >
                  <li className="nav-item">
                    <Link
                      className="nav-link fw-bold"
                      to="/home/create-template"
                      style={{
                        padding: isActive("/home/create-template")
                          ? "10px 15px"
                          : "",
                        color: isActive("/home/create-template") ? "#dcc05d" : "",
                        backgroundColor: isActive("/home/create-template")
                          ? "#dcc05d !important"
                          : "",
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                      }}
                    >
                      <FilePlus2 size={18} />&nbsp;Nueva
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link fw-bold"
                      to="/home/view-my-template"
                      style={{
                        padding: isActive("/home/view-my-template")
                          ? "10px 15px"
                          : "",
                        color: isActive("/home/view-my-template") ? "#dcc05d" : "",
                        backgroundColor: isActive("/home/view-my-template")
                          ? "#dcc05d !important"
                          : "",
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                      }}
                    >
                      <ChevronsDown size={18} />&nbsp;Mis plantillas
                    </Link>
                  </li>
                  {arrayUsers?.role === "ADMINISTRADOR" ? (
                    <>
                      <li className="nav-item ">
                        <Link
                          className="nav-link fw-bold"
                          to="/home/view-template"
                          style={{
                            padding: isActive("/home/view-template")
                              ? "10px 15px"
                              : "",
                            color: isActive("/home/view-template")
                              ? "#dcc05d"
                              : "",
                            backgroundColor: isActive("/home/view-template")
                              ? "#dcc05d !important"
                              : "",
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          <GalleryHorizontal size={20} />&nbsp;Todas las plantillas
                        </Link>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            )}
          </li>

          {arrayUsers?.role === "ADMINISTRADOR" ? (
            <>
              <li style={{ color: "black" }} className="nav-item">
                <span
                  className="nav-link fs-5 fw-bold text-white"
                  onClick={() => toggleSupportMenu("user")}
                  style={{
                    cursor: "pointer",
                    padding: "10px 15px",
                    color: "white !important",
                    backgroundColor: "transparent !important",
                  }}
                >
                  <UserCheck size={18} />&nbsp;Usuarios
                </span>

                {/* Menú desplegable de Usuarios */}
                {isSupportMenuOpen === "user" && (
                  <div className={`submenu ${isSupportMenuOpen === "user" ? "open" : ""}`}>
                    <ul
                      className="nav flex-column ms-3"
                      style={{ background: "transparent" }}
                    >
                      <li className="nav-item">
                        <Link
                          className="nav-link fw-bold"
                          to="/home/create-user"
                          style={{
                            padding: isActive("/home/create-user")
                              ? "10px 15px"
                              : "",
                            color: isActive("/home/create-user") ? "#dcc05d" : "",
                            backgroundColor: isActive("/home/create-user")
                              ? "#dcc05d !important"
                              : "",
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          <FilePlus2 size={18} />&nbsp;Creación
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link fw-bold"
                          to="/home/view-user"
                          style={{
                            padding: isActive("/home/view-user")
                              ? "10px 15px"
                              : "",
                            color: isActive("/home/view-user") ? "#dcc05d" : "",
                            backgroundColor: isActive("/home/view-user")
                              ? "#dcc05d !important"
                              : "",
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          <UsersRound size={18} />&nbsp;Listado
                        </Link>
                      </li>
                    </ul>
                  </div>

                )}
              </li>
            </>
          ) : (
            ""
          )}
          {arrayUsers?.role === "ADMINISTRADOR" || arrayUsers?.role === "CAPACITACION" || arrayUsers?.role === "AUDITORIA" ? (<>
            <li className="nav-item">
              <span
                className="nav-link fs-5 fw-bold text-white"
                onClick={() => toggleSupportMenu("ips")}
                style={{
                  cursor: "pointer",
                  padding: "10px 15px",
                  color: "white !important",
                  backgroundColor: "transparent !important",
                }}
              >
                <Hospital size={18} />&nbsp;IPS
              </span>

              {/* Menú desplegable de IPS */}

              {isSupportMenuOpen === "ips" && (
                <div className={`submenu ${isSupportMenuOpen === "ips" ? "open" : ""}`}>
                  <ul
                    className="nav flex-column ms-3"
                    style={{ background: "transparent" }}
                  >
                    <li className="nav-item">
                      <Link
                        className="nav-link fw-bold"
                        to="/home/ips-view"
                        style={{
                          padding: isActive("/home/ips-view")
                            ? "10px 15px"
                            : "",
                          color: isActive("/home/ips-view") ? "#dcc05d" : "",
                          backgroundColor: isActive("/home/ips-view")
                            ? "#dcc05d !important"
                            : "",
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                        }}
                      >
                        <List size={18} />&nbsp;Listado
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link fw-bold"
                        to="/home/ips-view-lovelace"
                        style={{
                          padding: isActive("/home/ips-view-lovelace")
                            ? "10px 15px"
                            : "",
                          color: isActive("/home/ips-view-lovelace") ? "#dcc05d" : "",
                          backgroundColor: isActive("/home/ips-view-lovelace")
                            ? "#dcc05d !important"
                            : "",
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                        }}
                      >
                        <ListCheck size={18} />&nbsp;Lovelace
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link fw-bold"
                        to="/home/ips-view-movil"
                        style={{
                          padding: isActive("/home/ips-view-movil")
                            ? "10px 15px"
                            : "",
                          color: isActive("/home/ips-view-movil") ? "#dcc05d" : "",
                          backgroundColor: isActive("/home/ips-view-movil")
                            ? "#dcc05d !important"
                            : "",
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                        }}
                      >
                        <Rows4 size={18} />&nbsp;Movil
                      </Link>
                    </li>
                  </ul>
                </div>

              )}
            </li>
          </>) : ("")}
          {arrayUsers?.role === "ADMINISTRADOR" || arrayUsers?.role === "CAPACITACION" ? (
            <>
              <li className="nav-item">
                <span
                  className="nav-link fs-5 fw-bold text-white"
                  onClick={() => toggleSupportMenu("apsRocky")}
                  style={{
                    cursor: "pointer",
                    padding: "10px 15px",
                    color: "white !important",
                    backgroundColor: "transparent !important",
                  }}
                >
                  <Smartphone size={18} />&nbsp;APP ROCKY
                </span>

                {isSupportMenuOpen === "apsRocky" && (
                  <div className={`submenu ${isSupportMenuOpen === "apsRocky" ? "open" : ""}`}>
                    <ul
                      className="nav flex-column ms-3"
                      style={{ background: "transparent" }}
                    >
                      <li className="nav-item">
                        <Link
                          className="nav-link fw-bold"
                          to="/home/view-auth-device"
                          style={{
                            padding: isActive("/home/view-auth-device")
                              ? "10px 15px"
                              : "",
                            color: isActive("/home/view-auth-device") ? "#dcc05d" : "",
                            backgroundColor: isActive("/home/view-auth-device")
                              ? "#dcc05d !important"
                              : "",
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          <List size={18} />&nbsp;Listado
                        </Link>
                      </li>
                    </ul>
                  </div>

                )}
              </li></>) : (
            ""
          )}
          {arrayUsers?.role === "ADMINISTRADOR" ? (
            <>
              <li className="nav-item">
                <span
                  className="nav-link fs-5 fw-bold text-white"
                  onClick={() => toggleSupportMenu("news")}
                  style={{
                    cursor: "pointer",
                    padding: "10px 15px",
                    color: "white !important",
                    backgroundColor: "transparent !important",
                  }}
                >
                  <Newspaper size={18} />&nbsp;Noticias
                </span>

                {isSupportMenuOpen === "news" && (
                  <div className={`submenu ${isSupportMenuOpen === "news" ? "open" : ""}`}>
                    <ul
                      className="nav flex-column ms-3"
                      style={{ background: "transparent" }}
                    >
                      <li className="nav-item">
                        <Link
                          className="nav-link fw-bold"
                          to="/home/view-all-news"
                          style={{
                            padding: isActive("/home/view-all-news")
                              ? "10px 15px"
                              : "",
                            color: isActive("/home/view-all-news") ? "#dcc05d" : "",
                            backgroundColor: isActive("/home/view-all-news")
                              ? "#dcc05d !important"
                              : "",
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          <List size={18} />&nbsp;Listado
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link fw-bold"
                          to="/home/create-news"
                          style={{
                            padding: isActive("/home/create-news")
                              ? "10px 15px"
                              : "",
                            color: isActive("/home/create-news") ? "#dcc05d" : "",
                            backgroundColor: isActive("/home/create-news")
                              ? "#dcc05d !important"
                              : "",
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          <ClipboardPlus size={18} />&nbsp;Creación
                        </Link>
                      </li>
                    </ul>
                  </div>

                )}
              </li></>) : (
            ""
          )}
        </ul>
      </nav>
    </>
  );
};
